<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<EgrantyErrorListPopup
			title="Nie udało się opublikować konkursu:"
			:error-list="announcementErrors.messages"
			:is-open="announcementErrors.showPopup"
			@close="closeAnnouncementErrorsPopup"/>

		<v-card class="mt-4 contest-main-data">
			<v-card-title class="mb-3">
				<h2>Parametry konkursu</h2>
				<v-spacer/>
			</v-card-title>

			<div>
				<v-btn class="ml-3" @click="save" color="primary">Zapisz zmiany</v-btn>
			</div>

			<v-card-text>
				<v-layout class="py-3">
					<v-flex xs6>
						<v-layout class="mt-2" row wrap>
							<v-flex xs3>
								<v-subheader>Pełna nazwa konkursu</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-text-field
									browser-autocomplete="off"
									label="Pełna nazwa konkursu"
									aria-label="full contest name"
									for="contest-main-data-view-full-name-recruitment"
									id="contest-main-data-view-full-name-recruitment"
									v-model="contestData.name">
								</v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Skrócona nazwa konkursu</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-text-field
									:disabled="contestInfo.contestStatus !== 'NEW'"
									browser-autocomplete="off"
									label="Skrócona nazwa konkursu"
									aria-label="short contest name"
									for="contest-main-data-view-short-name-recruitment"
									id="contest-main-data-view-short-name-recruitment"
									v-model="contestData.shortName">
								</v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Początek naboru ofert</v-subheader>
							</v-flex>
							<v-flex xs4 class="pr-4">
								<v-menu
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="contestData.contestStartDate"
									full-width
									lazy
									min-width="290px"
									offset-y
									ref="contestStartDateMenu"
									transition="scale-transition"
									v-model="contestStartDateMenu"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											browser-autocomplete="off"
											label="Data rozpoczęcia naboru ofert"
											aria-label="contest start date"
											for="contest-main-data-view-date-start-recruitment"
											id="contest-main-data-view-date-start-recruitment"
											prepend-icon="event"
											readonly
											v-model="contestData.contestStartDate"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker no-title scrollable
										:first-day-of-week="1"
										v-model="contestData.contestStartDate" locale="pl-PL">
										<v-spacer></v-spacer>
										<v-btn @click="contestStartDateMenu = false" color="primary" flat>Powrót</v-btn>
										<v-btn @click="$refs.contestStartDateMenu.save(contestData.contestStartDate)"
											color="primary"
											flat>OK
										</v-btn>
									</v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex xs4>
								<v-menu
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="contestData.contestStartTime"
									full-width
									lazy
									max-width="290px"
									min-width="290px"
									offset-y
									ref="contestStartTimeMenu"
									transition="scale-transition"
									v-model="contestStartTimeMenu"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											browser-autocomplete="off"
											label="Czas rozpoczęcia naboru ofert"
											aria-label="contest start time"
											for="contest-main-data-view-time-start-recruitment"
											id="contest-main-data-view-time-start-recruitment"
											prepend-icon="access_time"
											readonly
											v-model="contestData.contestStartTime"
											v-on="on"
										></v-text-field>
									</template>
									<v-time-picker
										@click:minute="$refs.contestStartTimeMenu.save(contestData.contestStartTime)"
										format="24hr"
										full-width
										v-if="contestStartTimeMenu"
										v-model="contestData.contestStartTime"
									></v-time-picker>
								</v-menu>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Koniec naboru ofert</v-subheader>
							</v-flex>
							<v-flex xs4 class="pr-4">
								<v-menu
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="contestData.contestEndDate"
									full-width
									lazy
									min-width="290px"
									offset-y
									ref="contestEndDateMenu"
									transition="scale-transition"
									v-model="contestEndDateMenu"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											browser-autocomplete="off"
											label="Data zakończenia naboru ofert"
											aria-label="contest end date"
											for="contest-main-data-view-date-end-recruitment"
											id="contest-main-data-view-date-end-recruitment"
											prepend-icon="event"
											readonly
											v-model="contestData.contestEndDate"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker no-title
										:first-day-of-week="1"
										scrollable v-model="contestData.contestEndDate" locale="pl-PL">
										<v-spacer></v-spacer>
										<v-btn @click="contestEndDateMenu = false" color="primary" flat>Powrót</v-btn>
										<v-btn @click="$refs.contestEndDateMenu.save(contestData.contestEndDate)"
											color="primary"
											flat>OK
										</v-btn>
									</v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex xs4>
								<v-menu
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="contestData.contestEndTime"
									full-width
									lazy
									max-width="290px"
									min-width="290px"
									offset-y
									ref="contestEndTimeMenu"
									transition="scale-transition"
									v-model="contestEndTimeMenu"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											browser-autocomplete="off"
											label="Czas zakończenia naboru ofert"
											aria-label="contest end time"
											for="contest-main-data-view-time-end-recruitment"
											id="contest-main-data-view-time-end-recruitment"
											prepend-icon="access_time"
											readonly
											v-model="contestData.contestEndTime"
											v-on="on"
										></v-text-field>
									</template>
									<v-time-picker
										@click:minute="$refs.contestEndTimeMenu.save(contestData.contestEndTime)"
										format="24hr"
										full-width
										v-if="contestEndTimeMenu"
										v-model="contestData.contestEndTime"
									></v-time-picker>
								</v-menu>
							</v-flex>
						</v-layout>

						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Formy prawne</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-autocomplete
									:items="legalForms"
									chips clearable
									deletable-chips
									aria-label="legal form"
									label="Formy prawne uprawnione do udziału w konkursie"
									multiple
									v-model="contestData.legalFormList"
									@change="reloadPossibleBiddersForLegalForms(true)">
								</v-autocomplete>
							</v-flex>
						</v-layout>
					</v-flex>

					<v-flex xs6>
						<v-tooltip class="ml-2" bottom max-width="480px">
							<template v-slot:activator="{ on }">
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>
								Należy zwrócić uwagę na zgodność terminów realizacji projektu i jego poszczególnych modułów
							</span>
						</v-tooltip>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Rok realizacji</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-select :items="realizationYears"
									item-text="value"
									item-value="id"
									:disabled="additionalSettingsDisabled"
									label="Rok realizacji projektów jednorocznych"
									aria-label="realization years"
									for="contest-main-data-view-relization-year"
									id="contest-main-data-view-realization-year"
									v-model="contestData.realizationYearId"></v-select>
							</v-flex>
							<v-flex xs2/>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Początek projektu</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-menu
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="contestData.projectStartDate"
									full-width
									lazy
									min-width="290px"
									offset-y
									ref="projectStartDateMenu"
									transition="scale-transition"
									v-model="projectStartDateMenu"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											browser-autocomplete="off"
											label="Najwcześniejsza data rozpoczęcia projektu"
											for="contest-main-data-view-earlier-date-start-project"
											id="contest-main-data-view-earlier-date-start-project"
											aria-label="project start date"
											prepend-icon="event"
											readonly
											v-model="contestData.projectStartDate"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker no-title
										:first-day-of-week="1"
										scrollable v-model="contestData.projectStartDate" locale="pl-PL">
										<v-spacer></v-spacer>
										<v-btn @click="projectStartDateMenu = false" color="primary">Powrót</v-btn>
										<v-btn @click="$refs.projectStartDateMenu.save(contestData.projectStartDate)"
											color="primary">OK
										</v-btn>
									</v-date-picker>
								</v-menu>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Koniec projektu</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-menu
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="contestData.projectEndDate"
									full-width
									lazy
									min-width="290px"
									offset-y
									ref="projectEndDateMenu"
									transition="scale-transition"
									v-model="projectEndDateMenu"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											browser-autocomplete="off"
											label="Najpóźniejsza data zakończenia projektu"
											for="contest-main-data-view-latest-date-end-project"
											id="contest-main-data-view-latest-date-end-project"
											aria-label="project end date"
											prepend-icon="event"
											readonly
											v-model="contestData.projectEndDate"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker no-title scrollable
										:first-day-of-week="1"
										v-model="contestData.projectEndDate" locale="pl-PL">
										<v-spacer></v-spacer>
										<v-btn @click="projectEndDateMenu = false" color="primary">Powrót</v-btn>
										<v-btn @click="$refs.projectEndDateMenu.save(contestData.projectEndDate)"
											color="primary">OK
										</v-btn>
									</v-date-picker>
								</v-menu>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Strona internetowa</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-text-field
									browser-autocomplete="off"
									aria-label="contest page"
									label="Strona internetowa z ogłoszeniem o danym konkursie"
									for="contest-main-data-view-contest-page"
									id="contest-main-data-view-contest-page"
									type="text" v-model="contestData.contestPage"></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs3>
								<v-subheader>Oferenci</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-autocomplete
									:items="allPossibleBiddersForLegalForms"
									chips clearable
									item-text="polishName"
									item-value="id"
									deletable-chips
									aria-label="legal form"
									label="Oferenci uprawnieni do udziału w konkursie"
									multiple
									v-model="contestData.allowedContestBidders"
									return-object
									@focus="reloadPossibleBiddersForLegalForms">
								</v-autocomplete>
							</v-flex>
						</v-layout>
						<v-layout row wrap v-if="contestInfo.contestStatus === 'FINISHED'">
							<v-flex xs3>
								<v-subheader>Wyniki konkursu</v-subheader>
							</v-flex>
							<v-flex xs8>
								<v-text-field
									browser-autocomplete="off"
									aria-label="result page"
									label="Strona internetowa z wynikami konkursu"
									for="contest-main-data-view-contest-result-page"
									id="contest-main-data-view-contest-result-page"
									type="text" v-model="contestData.resultPage"></v-text-field>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>

				<v-layout row wrap class="mt-3">
					<v-flex xs1/>
					<v-flex xs5>
						<v-layout wrap>
							<v-flex xs9>
								<v-subheader>{{contestData.manyTasks ?
									"Wniosek może dotyczyć wielu zadań" :
									"Wniosek może dotyczyć tylko jednego zadania"}}
								</v-subheader>
							</v-flex>
							<v-flex xs3>
								<v-switch aria-label="label for switch"
									v-model="contestData.manyTasks"
								></v-switch>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs5>
						<v-layout wrap>
							<v-flex xs9>
								<v-subheader>{{contestData.manyAccreditationCountries ?
									"Wniosek może dotyczyć wielu krajów" :
									"Wniosek może dotyczyć tylko jednego kraju"}}
								</v-subheader>
							</v-flex>
							<v-flex xs3>
								<v-switch aria-label="label for switch"
									v-model="contestData.manyAccreditationCountries"
								></v-switch>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs1/>
				</v-layout>

				<v-layout row wrap class="mt-1">
					<v-flex xs1/>
					<v-flex xs5>
						<v-layout wrap>
							<v-flex xs9>
								<v-subheader>{{contestData.manyPriorities ?
									"Wniosek może dotyczyć wielu priorytetów" :
									"Wniosek może dotyczyć tylko jednego priorytetu"}}
								</v-subheader>
							</v-flex>
							<v-flex xs3>
								<v-switch aria-label="label for switch"
									v-model="contestData.manyPriorities"
								></v-switch>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs5>
						<v-layout wrap>
							<v-flex xs9>
								<v-subheader>{{contestData.manyAreas ?
									"Wniosek może dotyczyć wielu obszarów" :
									"Wniosek może dotyczyć tylko jednego obszaru"}}
								</v-subheader>
							</v-flex>
							<v-flex xs3>
								<v-switch aria-label="label for switch"
									v-model="contestData.manyAreas"
								></v-switch>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs1/>
				</v-layout>

				<v-layout row mt-4>
					<v-flex xs2>
						<v-subheader>Hint pod działaniami</v-subheader>
					</v-flex>
					<v-flex xs8>
						<v-textarea
							browser-autocomplete="off"
							style="padding-right: 20px"
							aria-label="activities table hint"
							:outline="true"
							:required="false"
							auto-grow
							type="text" v-model="contestData.activitiesTableHint"></v-textarea>
					</v-flex>
				</v-layout>

				<v-layout row mt-4>
					<v-flex xs2>
						<v-subheader>Hint pod budżetem</v-subheader>
					</v-flex>
					<v-flex xs8>
						<v-textarea
							browser-autocomplete="off"
							style="padding-right: 20px"
							aria-label="financial table hint"
							:outline="true"
							:required="false"
							auto-grow
							type="text" v-model="contestData.financialTableHint"></v-textarea>
					</v-flex>
				</v-layout>

				<v-layout row mt-3>
					<v-flex xs2>
						<v-subheader>Informacja wstępna w podglądzie formularza oferty</v-subheader>
					</v-flex>
					<v-flex xs8>
						<v-textarea
							browser-autocomplete="off"
							style="padding-right: 20px"
							aria-label="empty offer hint"
							:outline="true"
							:required="false"
							auto-grow
							type="text" v-model="contestData.emptyOfferHint"></v-textarea>
					</v-flex>
				</v-layout>
			</v-card-text>

			<v-card-title class="mt-4 mb-4">
				<h2>Dodatkowe ustawienia</h2>
				<v-spacer/>
			</v-card-title>

			<v-card-text>
				<v-layout class="mb-5">
					<v-flex xs6 class="ml-4 mr-4">
						<h4 class="ma-3">Udział wolontariuszy</h4>
						<egranty-switch
							:disabled="additionalSettingsDisabled"
							v-model="contestData.volunteerParticipation"
							:title="contestData.volunteerParticipation ?
								'Udział wolontariuszy jest możliwy' :
								'Udział wolontariuszy nie jest możliwy'"
							aria-label="volunteer participation enabled"
						></egranty-switch>
						<v-expand-transition>
							<div v-if="contestData.volunteerParticipation">
								<egranty-switch
									:disabled="additionalSettingsDisabled"
									v-model="contestData.volunteersCompulsory"
									:title="contestData.volunteersCompulsory ?
										'Wolontariusze obowiązkowi' :
										'Wolontariusze opcjonalni'"
									aria-label="volunteers compulsory"
								></egranty-switch>
								<v-layout row wrap>
									<v-flex xs8>
										<v-subheader>Limit wolontariuszy na moduł</v-subheader>
									</v-flex>
									<v-flex xs3>
										<v-text-field
											browser-autocomplete="off"
											:disabled="additionalSettingsDisabled"
											type="number"
											label="Limit"
											aria-label="volunteer limit"
											for="contest-main-data-view-limit-volunteer"
											id="contest-main-data-view-limit-volunteer"
											min="1"
											v-model="contestData.volunteerLimit"
										></v-text-field>
									</v-flex>
									<v-flex xs1/>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs8>
										<v-subheader>Minimalna liczba dni za granicą</v-subheader>
									</v-flex>
									<v-flex xs3>
										<v-text-field
											browser-autocomplete="off"
											:disabled="additionalSettingsDisabled"
											type="number"
											label="Liczba dni"
											aria-label="minimum days abroad"
											for="contest-main-data-view-number-days"
											id="contest-main-data-view-number-days"
											min="1"
											v-model="contestData.minDaysAbroad"
										></v-text-field>
									</v-flex>
									<v-flex xs1/>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs8>
										<v-subheader>Liczba raportów do przekazania</v-subheader>
									</v-flex>
									<v-flex xs3>
										<v-text-field
											browser-autocomplete="off"
											:disabled="additionalSettingsDisabled"
											type="number"
											label="Liczba raportów"
											aria-label="number of reports"
											for="contest-main-data-view-number-report"
											id="contest-main-data-view-number-report"
											min="1"
											v-model="contestData.reportNumber"
										></v-text-field>
									</v-flex>
									<v-flex xs1/>
								</v-layout>
								<volunteer-report-dates
									v-if="contestData.volunteerParticipation"
									:disabled="additionalSettingsDisabled"
									:report-number="contestData.reportNumber"
									:report-dates="contestData.reportDates"
									v-on:update-reports="updateReports"
								></volunteer-report-dates>
							</div>
						</v-expand-transition>
					</v-flex>
					<v-flex xs6 class="ml-4 mr-4">
						<h4 class="ma-3">Limit ofert</h4>
						<egranty-switch
							:disabled="additionalSettingsDisabled"
							v-model="settings.maxOfferLimitPerBidderEnabled"
							:title="settings.maxOfferLimitPerBidderEnabled ?
								'Limit ofert na oferenta jest sprecyzowany' :
								'Limit ofert na oferenta nie jest sprecyzowany'"
							aria-label="offer limit per bidder enabled"
						></egranty-switch>
						<v-expand-transition>
							<div v-show="settings.maxOfferLimitPerBidderEnabled">
								<v-layout row wrap>
									<egranty-switch
										:disabled="additionalSettingsDisabled"
										v-model="settings.mutualOffersIncludedInLimit"
										:title="settings.mutualOffersIncludedInLimit ?
											'Oferty wspólne wliczane do limitu' :
											'Oferty wspólne nie wliczane do limitu'"
										aria-label="offer limit per bidder enabled"
									></egranty-switch>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs8>
										<v-subheader>Limit ofert</v-subheader>
									</v-flex>
									<v-flex xs3>
										<v-text-field
											browser-autocomplete="off"
											type="number"
											:disabled="additionalSettingsDisabled"
											v-model="settings.maxOfferLimitPerBidderValue"
											label="Limit"
											aria-label="max offer limit per bidder value"
											for="contest-main-data-view-limit-offers"
											id="contest-main-data-view-limit-offers"
										></v-text-field>
									</v-flex>
									<v-flex xs1/>
								</v-layout>
							</div>
						</v-expand-transition>
					</v-flex>
					
				</v-layout>

				<v-layout class="mb-5">
					<v-flex xs6 class="ml-4 mr-4">
						<h4 class="ma-3">Oferty modułowe</h4>
						<egranty-switch
							:disabled="additionalSettingsDisabled"
							v-model="settings.modularOfferSettings.modularOffersEnabled"
							aria-label="modular offers enabled"
							:title="settings.modularOfferSettings.modularOffersEnabled ?
								'Można realizować oferty modułowe' : 'Nie można realizować ofert modułowych'"
						></egranty-switch>
						<v-expand-transition>
							<div v-show="settings.modularOfferSettings.modularOffersEnabled">
								<v-layout row>
									<contest-possible-modules-count
										ref="modulesCount"
										v-model="settings.modularOfferSettings.possibleModulesCount"
										:disabled="additionalSettingsDisabled"
									></contest-possible-modules-count>
								</v-layout>
								<v-layout row>
									<egranty-text-input-field
										class="ma-2"
										v-model="settings.modularOfferSettings.modularOffersAnnouncement"
										:disabled="additionalSettingsDisabled"
										label="Komunikat dla oferentów składających oferty modułowe"
										for="contest-main-data-view-statement-bidders"
										id="contest-main-data-view-statement-bidders"
										:textarea="true"
										:required="false"
										:outline="false"
									></egranty-text-input-field>
								</v-layout>
								<v-container class="pa-0">
									<v-tooltip class="ml-2" bottom max-width="480px">
							<template v-slot:activator="{ on }">
								<v-icon style="position:absolute; left: 0.5em;" color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>
								Należy zwrócić uwagę na zgodność terminów realizacji projektu i jego poszczególnych modułów
							</span>
						</v-tooltip>
									<v-container row class="pa-0"
										v-for="(moduleCount, index) in settings.modularOfferSettings.possibleModulesTime"
										v-bind:key="index">
										<v-container row class="d-flex pa-0">
										<v-flex xs4>
											<v-subheader class="mt-2">Początek modułu {{ moduleCount.moduleNumber }}</v-subheader>
										</v-flex>
										<v-flex xs8>
											<v-menu :close-on-content-click="false" :nudge-right="40" full-width
												min-width="290px" offset-y transition="scale-transition"
												v-model="moduleCount.moduleStartDateTempVariable"
												:return-value.sync="moduleCount.moduleStartDate"
												ref="moduleCountStartDate">
												<template v-slot:activator="{ on }">
													<v-text-field label="Najwcześniejsza data rozpoczęcia modułu"
														prepend-icon="event" readonly v-model="moduleCount.moduleStartDate"
														v-on="on" :disabled="additionalSettingsDisabled"></v-text-field>
												</template>
												<v-date-picker no-title :first-day-of-week="1" scrollable
													v-model="moduleCount.moduleStartDate" locale="pl-PL">
													<v-spacer></v-spacer>
													<v-btn @click="moduleCount.moduleStartDateTempVariable = false"
														color="primary">Powrót</v-btn>
													<v-btn @click="$refs.moduleCountStartDate[index].save(moduleCount.moduleStartDate)" color="primary">OK
													</v-btn>
												</v-date-picker>
											</v-menu>
										</v-flex>
									</v-container>
										<v-container row class="d-flex pa-0">
										<v-flex xs4>
											<v-subheader class="mt-2">Koniec modułu {{ moduleCount.moduleNumber }}</v-subheader>
										</v-flex>
										<v-flex xs8>
											<v-menu :close-on-content-click="false" :nudge-right="40" full-width lazy
												min-width="290px" offset-y transition="scale-transition"
												v-model="moduleCount.moduleEndDateTempVariable"
												:return-value.sync="moduleCount.moduleEndDate"
												ref="moduleCountEndDate">
												<template v-slot:activator="{ on }">
													<v-text-field label="Najpóźniejsza data zakończenia modułu"
														prepend-icon="event" readonly v-model="moduleCount.moduleEndDate"
														v-on="on" :disabled="additionalSettingsDisabled"></v-text-field>
												</template>
												<v-date-picker no-title :first-day-of-week="1" scrollable
													v-model="moduleCount.moduleEndDate" locale="pl-PL">
													<v-spacer></v-spacer>
													<v-btn @click="moduleCount.moduleEndDateTempVariable = false"
														color="primary">Powrót</v-btn>
													<v-btn @click="$refs.moduleCountEndDate[index].save(moduleCount.moduleEndDate)" color="primary">OK
													</v-btn>
												</v-date-picker>
											</v-menu>
										</v-flex>
										</v-container>
									</v-container>
								</v-container>
							</div>
						</v-expand-transition>
					</v-flex>
					<v-flex xs6 class="ml-4 mr-4">
						<h4 class="ma-3">Parametry sprawozdania</h4>
						<egranty-switch
							:disabled="additionalSettingsDisabled"
							v-model="settings.financialDocumentsIncluded"
							:title="settings.financialDocumentsIncluded ?
								'Sprawozdanie końcowe obejmuje dokumenty finansowe' :
								'Sprawozdanie końcowe nie obejmuje dokumentów finansowych'"
							aria-label="offer limit per bidder enabled"
						></egranty-switch>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>

		<empty-result-page-dialog-view
			:show-dialog.sync="emptyResultPageError"
		></empty-result-page-dialog-view>
	</div>
</template>

<script>
	import {PublicContest} from "@/api/generated/PublicContest";
	import EgrantySwitch from "../../../genericComponents/EgrantySwitch";
	import VolunteerReportDates from "./VolunteerReportDates";
	import {ContestRealizationYear} from "@/api/generated/ContestRealizationYear";
	import ContestPossibleModulesCount from "./components/ContestPossibleModulesCount";
	import EgrantyTextInputField from "../../../genericComponents/EgrantyTextInputField";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";
	import {getDictionary} from "@/utils/LegalFormDictionary";
	import {createLabels} from "@/utils/createLabels";
	import EmptyResultPageDialogView from "./components/EmptyResultPageDialogView";

	export default {
		name: "ContestMainData",
		components: {
			EmptyResultPageDialogView,
			EgrantyErrorListPopup,
			EgrantyTextInputField,
			ContestPossibleModulesCount,
			EgrantySwitch,
			VolunteerReportDates,
		},
		computed: {
			possibleModulesCountLentgh(){
				return this.settings.modularOfferSettings.possibleModulesCount ? this.settings.modularOfferSettings.possibleModulesCount.length : [];
			},
			maxContestStartDate () {
				return this.contestData.contestEndDate;
			},
			minContestEndDate () {
				return this.contestData.contestStartDate;
			},
			maxContestEndDate () {
				return this.contestData.projectStartDate;
			},
			minProjectStartDate () {
				return this.contestData.contestEndDate;
			},
			maxProjectStartDate () {
				return this.contestData.projectEndDate;
			},
			minProjectEndDate () {
				return this.contestData.projectStartDate;
			},
      additionalSettingsDisabled () {
        return this.contestInfo.announced || this.contestInfo.hasAnyProjectGenerated;
      }
		},

		methods: {
			reloadPossibleBiddersForLegalForms(refreshSelectedBidders = false){
				if(this.contestData.legalFormList.length == 0){
					this.allPossibleBiddersForLegalForms = [];
					return;
				}
				PublicContest.getContestLegalFormsPossibleBidders(this, this.$route.params.id,this.contestData.legalFormList, response => {
				this.allPossibleBiddersForLegalForms = response;
				if(refreshSelectedBidders && this.contestData.allowedContestBidders && this.contestData.allowedContestBidders.length>0){
						this.contestData.allowedContestBidders = this.contestData.allowedContestBidders.filter(user => {
   						return this.allPossibleBiddersForLegalForms.some(bidder => bidder.polishName == user.polishName);
					});
				}
			});
			},
			generatePossibleModuleTimes(){
				let maxValues = this.settings.modularOfferSettings.possibleModulesCount.reduce((prev, current) => (current.count > prev.count) ? current : prev, { count: -Infinity });
				if(this.settings.modularOfferSettings.possibleModulesTime && maxValues.count > this.settings.modularOfferSettings.possibleModulesTime.length){
				for(let i = 0; i < maxValues.count; i++){
					if(this.settings.modularOfferSettings.possibleModulesTime == undefined){
						this.$set(this.settings.modularOfferSettings, 'possibleModulesTime', []); // być może do przerobienia potem, jak będzie pobierane z serwera
					}
					if(!this.settings.modularOfferSettings.possibleModulesTime[i]){
						this.settings.modularOfferSettings.possibleModulesTime.push({moduleStartDate:null,moduleEndDate: null, moduleStartDateTempVariable: false, moduleNumber: i+1});
					}
				}
			} else if(this.settings.modularOfferSettings.possibleModulesTime && maxValues.count < this.settings.modularOfferSettings.possibleModulesTime.length){
				this.settings.modularOfferSettings.possibleModulesTime.splice(maxValues.count,this.settings.modularOfferSettings.possibleModulesTime.length-maxValues.count);
			}
			},
			isLoading () {
				let apiLoaders = this.dataState.apiLoaders;
				return !(apiLoaders.contestDataLoaded
					&& apiLoaders.yearsLoaded
					&& apiLoaders.userRoleLoaded
					&& apiLoaders.contestStateLoaded);
			},

			resultPageSet () {
				return this.contestData.resultPage !== null
            && this.contestData.resultPage !== undefined
            && this.contestData.resultPage.trim() !== "";
			},

			prepareRequest () {
				if (this.contestData.contestStartDate !== null &&
					this.contestData.contestStartTime === null) {
					this.contestData.contestStartTime = "00:00";
				}
				if (this.contestData.contestEndDate !== null &&
					this.contestData.contestEndTime === null) {
					this.contestData.contestEndTime = "00:00";
				}
				if (this.contestData.projectStartDate !== null &&
					this.contestData.projectStartTime === null) {
					this.contestData.projectStartTime = "00:00";
				}
				if (this.contestData.projectEndDate !== null &&
					this.contestData.projectEndTime === null) {
					this.contestData.projectEndTime = "00:00";
				}
				if (this.contestData.contestStartTime !== null &&
					this.contestData.contestStartDate === null) {
					this.contestData.contestStartTime = null;
				}
				if (this.contestData.contestEndTime !== null &&
					this.contestData.contestEndDate === null) {
					this.contestData.contestEndTime = null;
				}
				if (this.contestData.projectStartTime !== null &&
					this.contestData.projectStartDate === null) {
					this.contestData.projectStartTime = null;
				}
				if (this.contestData.projectEndTime !== null &&
					this.contestData.projectEndDate === null) {
					this.contestData.projectEndTime = null;
				}
				this.contestData.reportDates = this.contestData.reportDates.slice(0, this.contestData.reportNumber);
				if (this.contestData.volunteerLimit < 1) this.contestData.volunteerLimit = 1;
				if (this.contestData.minDaysAbroad < 0) this.contestData.minDaysAbroad = 0;
				if (this.contestData.reportNumber < 0) this.contestData.reportNumber = 0;
			},

			save () {
				if (this.contestInfo.contestStatus === "FINISHED" && !this.resultPageSet()) {
					this.emptyResultPageError = true;
					return;
				}
				this.prepareRequest();
				PublicContest.putData(this, this.contestData, () => {
						PublicContest.putGeneralSettings(this, this.$route.params.id, this.settings, () => {
							this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane");
							this.dataLoaded();
							this.$parent.updateNames(this.contestData.name, this.contestData.shortName);
						}, errorResponse => {
              let message = "Dodatkowe ustawienia nie zostały zapisane";
              if (errorResponse.message === "Zmiana parametrów sprawozdania po wygenerowaniu projektów jest niemożliwa") {
                message = message.concat(". ").concat(errorResponse.message);
              }
              this.$messagesBus.$emit("error", message, errorResponse);
            });
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
					});
			},

			updateReports (reportNum, dates) {
				this.contestData.reportNumber = reportNum;
				this.contestData.reportDates = dates;
			},

			dataLoaded () {
				this.dataState.stale = false;
			},

			closeAnnouncementErrorsPopup () {
				this.announcementErrors.showPopup = false;
			},
		},

		updated () {
			createLabels.addAriaLabelForInputWithRole("checkbox");
		},

		data () {
			return {
				contestData: {
					id: this.$route.params.id,
					name: "",
					shortName: "",
					departmentId: "",
					contestStartDate: "",
					contestStartTime: "",
					contestEndDate: "",
					contestEndTime: "",
					legalFormList: [],
					realizationYearId: "",
					projectStartDate: "",
					projectEndDate: "",
					projectStartTime: "",
					projectEndTime: "",
					contestPage: "",
					resultPage: "",
					volunteerParticipation: false,
					volunteerLimit: 1,
					minDaysAbroad: 0,
					volunteersCompulsory: false,
					reportDates: [],
					reportNumber: 1,
					announced: undefined,
					manyAccreditationCountries: false,
					activitiesTableHint: "",
					financialTableHint: "",
					emptyOfferHint: "",
					allowedContestBidders: []
				},
				allPossibleBiddersForLegalForms: [],
				settings: {
					modularOfferSettings: {
						modularOffersEnabled: false,
						modularOffersAnnouncement: null,
						possibleModulesCount: [],
						possibleModulesTime: [],
					},
					maxOfferLimitPerBidderEnabled: false,
          mutualOffersIncludedInLimit: true,
          financialDocumentsIncluded: false,
					maxOfferLimitPerBidderValue: null,
				},

				loggedUserRole: "",

				formState: {
					contestAnnounced: undefined,
				},

				dataState: {
					apiLoaders: {},
					stale: false,
				},

				contestStartDateMenu: false,
				contestStartTimeMenu: false,
				contestEndDateMenu: false,
				contestEndTimeMenu: false,
				projectStartDateMenu: false,
				projectStartTimeMenu: false,
				projectEndDateMenu: false,
				projectEndTimeMenu: false,

				realizationYears: [],
				legalForms: [],

				announcementErrors: {
					showPopup: false,
					messages: [],
				},
				emptyResultPageError: false,

				contestInfo: {
					contestStatus: undefined,
					announced: undefined,
					hasAnyProjectGenerated : undefined
				},
				moduleStartDateMenu: [],
				moduleStartDate: [],

			};
		},

		watch: {
			contestData: {
				deep: true,

				handler: function () {
					if (!this.isLoading()) {
						this.dataState.stale = true;
					}
				},
			},

			settings: {
				deep: true,

				handler: function () {
					if (!this.isLoading()) {
						this.dataState.stale = true;
					}
				},
			},

      "settings.maxOfferLimitPerBidderEnabled": {
        handler(val) {
          if (!val) {
            this.settings.mutualOffersIncludedInLimit = true;
            this.settings.maxOfferLimitPerBidderValue = null;
          }
        }
      },
	possibleModulesCountLentgh: {
		handler(val) {
					this.generatePossibleModuleTimes();
				},
		},

			"dataState.apiLoaders": function () {
				if (!this.isLoading()) {
					this.dataLoaded();
				}
			},
		},

		created () {
			this.dataState.apiLoaders = {};
			PublicContest.getStatus(this, this.$route.params.id, response => {
				this.contestInfo = response;
			});
			PublicContest.getData(this, this.$route.params.id, response => {
				this.contestData = response;
				this.contestData.id = this.$route.params.id;
				this.contestData.reportDates.sort(function (x, y) {
					return x.term - y.term;
				});
				this.dataState.apiLoaders["contestDataLoaded"] = true;
				createLabels.createLabelForMultipleAutocomplete();
				if(this.contestData.allowedContestBidders.length > 0){
				this.reloadPossibleBiddersForLegalForms();
				}
			});
			PublicContest.getGeneralSettings(this, this.$route.params.id, response => {
				this.settings = response;
				if (this.settings.modularOfferSettings.possibleModulesCount === null) {
					this.settings.modularOfferSettings.possibleModulesCount = [];
				}
			});
			ContestRealizationYear.getList(this, response => {
				response.items.forEach(element => {
					this.realizationYears.push(element);
				});
				this.realizationYears.sort(function (x, y) {
					return y.value - x.value;
				});
				this.dataState.apiLoaders["yearsLoaded"] = true;
			});
			PublicContest.getUserRole(this, this.contestData.id,
				successResponse => {
					this.loggedUserRole = successResponse;
					this.dataState.apiLoaders["userRoleLoaded"] = true;
				});

			let dict = getDictionary();
			for (let i = 0; i < Object.keys(dict).length; i++) {
				this.legalForms.push(dict[i]);
			}

		},
	};
</script>

<style scoped>
	.contest-main-data .v-input__prepend-outer {
		margin-left: 0;
	}
</style>
